export default {
  product_info: 'Productinfo',
  return: 'Terug naar opties',
};
